import { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from '@material-ui/lab';
import { Check as CheckIcon } from '@material-ui/icons';

import { Link, Logo } from 'components';
import { dynamicSort } from 'utils/arrays';

import { HEADERS, getCurrentVisibleStep } from '../constants';
import useStyles from './style';

function NavBar({ step }) {
  const classes = useStyles();
  const [headers, setHeaders] = useState();
  const [currentVisibleStep, setCurrentVisibleStep] = useState(null);

  useEffect(() => {
    const visibleHeaders = HEADERS
      .sort(dynamicSort('order'))
      .filter((header) => header.isVisible !== false);

    setHeaders(visibleHeaders);

    const activeVisibleStep = getCurrentVisibleStep(step, visibleHeaders);
    setCurrentVisibleStep(activeVisibleStep);
  }, [step]);

  if (!headers || currentVisibleStep === null) {
    return null;
  }

  return (<Box className={classes.container}>

    <Link to='/'>
      <Logo type="dark" />
    </Link>

    <Box>
      <Timeline align="left">
        {headers.map((header, index) => {
          const isActive = currentVisibleStep === header.order;
          const isCompleted = currentVisibleStep > header.order;
          const isPending = !isActive && !isCompleted;
          const displayNumber = index + 1;

          return (
            <TimelineItem key={index}>
              <TimelineSeparator>
                <TimelineDot
                  children={isActive
                    ? (<Typography
                      children={displayNumber}
                      className={classes.stepNumber}
                    />)
                    : isCompleted
                      ? <CheckIcon className={classes.check} />
                      : (<Typography
                        children={displayNumber}
                        className={classes.stepNumber}
                      />)}
                  className={clsx(
                    isPending && classes.dotPending,
                    isActive && classes.dotActive,
                    isCompleted && classes.dotFinished,
                  )}
                  variant="default"
                />
                {index < headers.length - 1 && (
                  <TimelineConnector
                    className={clsx(
                      classes.connector,
                      isPending && classes.connectorGreen,
                      (isActive || isCompleted) && classes.connector,
                    )}
                  />
                )}
              </TimelineSeparator>
              <TimelineContent>
                <Typography
                  className={clsx(
                    classes.stepTitle,
                    isPending && classes.stepTextInactive,
                  )}
                  children={`Paso ${displayNumber}`}
                  component="h1"
                  variant="h6"
                />
                <Typography
                  className={clsx(
                    classes.stepDescription,
                    isPending && classes.stepTextInactive,
                  )}
                  children={header.step}
                />
              </TimelineContent>
            </TimelineItem>
          );
        })}
      </Timeline>
    </Box>

  </Box>);
}

NavBar.propTypes = {
  step: PropTypes.number.isRequired,
};

export default NavBar;
